import React, { useState, useEffect } from "react";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Pagination } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { format, parseISO } from "date-fns";
import { useSubheader } from "../../../_metronic/layout/_core/MetronicSubheader";
import axios from "axios";
import DataTable from "react-data-table-component";
import { config } from "../../../config/envs";

const FilterComponent = ({ filterText, onClear, onFilter }) => (
  <>
    <input
      id="search"
      type="text"
      placeholder="Filtro"
      className="form-control"
      style={{ width: "200px" }}
      value={filterText}
      onChange={onFilter}
    />
  </>
);

export function Coupons() {
  const columns = [

    {
      name: "Ações",
      selector: row => row.id,
      width: "90px",
      cell: row => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Link to={`/coupons/${row.id}`}>
            <button
              type="button"
              className="btn btn-icon btn-primary"
              title="Editar"
            >
              <i className="flaticon-edit"></i>
            </button>
          </Link>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    },
    {
      name: "Cadastrado em",
      selector: row => row.created_at,
      width: "150px",
      cell: row => (
        <div>
          {row.created_at
            ? format(new Date(row.created_at), "dd/MM/yyyy HH:mm")
            : "Sem data de cadastro"}
        </div>
      ),
      sortable: true
    },
    {
      name: "Nome",
      selector: row => row.coupom,
      maxWidth: "180px"
    },
    {
      name: "Status",
      selector: row => (row.active ? "Ativo" : "Inativo"),
      width: "100px"
    },
    {
      name: "Dias de trial",
      selector: row => `${row.trial_days} dias`,
      width: "100px"
    },
    {
      name: "Duração",
      selector: row => `${row.periodicity} dias`,
      width: "100px"
    },
    {
      name: "Grupo de planos",
      selector: row => row.feature_group_name,
      width: "300px",
      cell: row => (
        <div title={`${row.feature_group_name}`}>{row.feature_group_name}</div>
      )
    },
    {
      name: "Valor",
      selector: row => `R$${row.old_amount}`,
      width: "100px"
    },
    {
      name: "Valor com Desconto",
      selector: row => `R$${row.amount}`,
      width: "160px"
    }
  ];

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );

  const fetchCoupons = async page => {
    setLoading(true);
    const response = await axios.get(
      config.app.adminBaseUrl +
        `/coupons/?page=${page}&per_page=${perPage}&filter=${filterText}`
    );

    setData(response.data.data.data);
    setTotalRows(response.data.data.totalItems);
    setLoading(false);
  };

  const handlePageChange = page => {
    fetchCoupons(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      config.app.adminBaseUrl +
        `/coupons/?page=${page}&per_page=${newPerPage}&filter=${filterText}`
    );

    setData(response.data.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={e => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  useEffect(() => {
    fetchCoupons(1);
  }, []);

  useEffect(() => {
    fetchCoupons(1);
  }, [filterText]);

  return (
    <>
      <h1 className="azul-cabecalho">Cupom</h1>
      <p className="subheader-text mb-10">Listagem de todos os Cupons</p>
      <Link to="/coupons/add">
        <button
          type="button"
          className="btn btn-icon btn-primary mb-10"
          style={{ width: "200px" }}
        >
          <i className="flaticon2-add"></i>&nbsp;&nbsp;Novo Cupom
        </button>
      </Link>

      <div className="row mb-10">
        <div style={{ overflowX: "auto", width: "100%" }}>
          <DataTable
            columns={columns}
            data={data}
            progressPending={loading}
            pagination
            perPage={perPage}
            paginationServer
            paginationTotalRows={totalRows}
            paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
          />
        </div>
      </div>
    </>
  );
}
